// extracted by mini-css-extract-plugin
module.exports = {"idea":"Ideas-module__idea___2C-xs","title":"Ideas-module__title___3fi2q","collapsed":"Ideas-module__collapsed___1_QsB","new":"Ideas-module__new___1yo0I"};